export const DISPLAY_MODE = {
    GRID: 'grid',
    PAGING: 'paging',
    SLIDER: 'slider',
    SIMPLE_GRID: 'simpleGrid'
};

export const GAME_SIZES = {
    EXTRA_SMALL: 'extraSmall',
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large'
};

export const GAME_WIDTHS = {
    [GAME_SIZES.EXTRA_SMALL]: {
        MOBILE: 69,
        DESKTOP: 69
    },
    [GAME_SIZES.MEDIUM]: {
        MOBILE: 158,
        DESKTOP: 235
    },
    [GAME_SIZES.LARGE]: {
        MOBILE: 254,
        DESKTOP: 300
    }
};
